import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { visuallyHidden } from "@mui/utils";
import CustomizedMenus from "../Button/ActionRegion";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, numSelected, rowCount, onRequestSort, columns } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead sx={{ width: "100%" }}>
      <TableRow>
        {columns.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const DataTableRegion = ({
  columns,
  rowsData,
  changePaginate,
  handleView,
  handleEdit,
  rowsPerPage,
  setRowsPerPage,
  pagination,
}) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setPage(pagination.currentPage - 1);
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.laporanKejadianId);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  // handle ganti halaman
  const handleChangePage = (event, newPage) => {
    changePaginate({
      page: parseInt(newPage) + 1,
      rowsPerPage,
    });
  };

  // handle ganti max row
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(1);
    changePaginate({
      page: 1,
      rowsPerPage: event.target.value,
    });
  };

  // Alert
  const [alertOpen, setAlertOpen] = useState(false);
  const [data, setData] = useState(null);
  const [type, setType] = useState(null);
  const [title, setTitle] = useState(null);
  const handleCloseAlert = () => {
    setAlertOpen(false);
  };

  // Assign
  const [assignOpen, setAssignOpen] = useState(false);

  // Dialog Save Berhasil
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOpen2(false);
  };

  // Dialog Save Gagal
  const [open3, setOpen3] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const handleClose3 = () => {
    setOpen3(false);
  };

  return (
    <Paper>
      <TableContainer sx={{ overflow: "visible" }}>
        <Table sx={{ minWidth: "100%" }} aria-labelledby="tableTitle">
          <EnhancedTableHead
            columns={columns}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <TableBody>
            {loading ? (
              <div className="spinerr">
                <CircularProgress />
              </div>
            ) : null}

            {rowsData.length > 0
              ? rowsData.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      // onClick={(event) => handleClick(event, row.name)}
                      role="checkbox"
                      //   aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      //   selected={isItemSelected}
                    >
                      <TableCell>
                        {parseInt(pagination.pageSize) *
                          parseInt(pagination.currentPage - 1) +
                          (index + 1)}
                      </TableCell>
                      <TableCell>{row.namaRegion}</TableCell>
                      <TableCell>{row.managerHsseEmail}</TableCell>
                      <TableCell>{row.managerHsseDisplayName}</TableCell>
                      <TableCell>{row.jabatanUser}</TableCell>
                      <TableCell>
                        <CustomizedMenus
                          handleView={handleView}
                          item={row}
                          handleEdit={handleEdit}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              : ""}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={pagination.totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default DataTableRegion;
